/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	MetaReachEstimateEstimateQueryParams,
	MetaReachEstimateEstimateResponse,
} from '../types/MetaReachEstimateEstimate'

/**
 * GET /meta/reach-estimate
 * @see backend/nexus/modules/MetaAd/Http/Controllers/MetaReachEstimateController.php MetaReachEstimateController::estimate
 */
export async function metaReachEstimateEstimate(
	params?: MetaReachEstimateEstimateQueryParams,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<MetaReachEstimateEstimateResponse>> {
	return axiosInstance.get('/meta/reach-estimate', { params, ...config })
}
